// DORMANT_FUNCTIONALITY_CLEANUP_V1
// Frontend-only category presentation and endpoint routing.
// Universal-search intent classification remains authoritative on the backend.

const CATEGORY_PRESENTATION = Object.freeze({
  coffee: Object.freeze({
    key: 'coffee', label: 'Coffee', emoji: '☕',
    modeLabel: '☕ Coffee mode', nearbyLabel: '☕ Coffee Nearby',
    endpoint: '/api/coffee-shops',
  }),
  brunch: Object.freeze({
    key: 'brunch', label: 'Brunch', emoji: '🥞',
    modeLabel: '🍳 Brunch mode', nearbyLabel: '🍳 Brunch Nearby',
    endpoint: '/api/brunch-spots',
  }),
  food: Object.freeze({
    key: 'food', label: 'Food', emoji: '🍝',
    modeLabel: '🍝 Food mode', nearbyLabel: '🍝 Food Nearby',
    endpoint: '/api/food-spots',
  }),
  bars: Object.freeze({
    key: 'bars', label: 'Bars', emoji: '🍸',
    modeLabel: '🍸 Happy hour mode', nearbyLabel: '🍸 Bars Nearby',
    endpoint: '/api/random-bars',
  }),
  clubs: Object.freeze({
    key: 'clubs', label: 'Clubs', emoji: '🪩',
    modeLabel: '🪩 Nightlife mode', nearbyLabel: '🪩 Nightlife Nearby',
    endpoint: '/api/clubs',
  }),
  karaoke: Object.freeze({
    key: 'karaoke', label: 'Karaoke', emoji: '🎤',
    modeLabel: '🎤 Karaoke mode', nearbyLabel: '🎤 Karaoke Nearby',
    endpoint: '/api/karaoke-spots',
  }),
  breweries: Object.freeze({
    key: 'breweries', label: 'Breweries', emoji: '🍺',
    modeLabel: '🍺 Brewery mode', nearbyLabel: '🍺 Breweries Nearby',
    endpoint: '/api/breweries',
  }),
  cannabis: Object.freeze({
    key: 'cannabis', label: 'Cannabis', emoji: '🌿',
    modeLabel: '🌿 Cannabis mode', nearbyLabel: '🌿 Cannabis Nearby',
    endpoint: '/api/dispensaries',
  }),
  late_night: Object.freeze({
    key: 'late_night', label: 'Late Night', emoji: '🌙',
    modeLabel: '🌃 Late night mode', nearbyLabel: '🌃 Late Night Nearby',
    endpoint: '/api/late-night',
  }),
  hidden_gems: Object.freeze({
    key: 'hidden_gems', label: 'Hidden Gems', emoji: '✨',
    modeLabel: '✨ Hidden Gems mode', nearbyLabel: '✨ Hidden Gems Nearby',
    endpoint: '/api/hidden-gems',
  }),
});

export function normalizeCategoryKey(value) {
  const raw = String(value || '').trim().toLowerCase();
  if (raw === 'bar') return 'bars';
  if (raw === 'brewery') return 'breweries';
  if (raw === 'lunch' || raw === 'dinner') return 'food';
  return raw;
}

export function getCategoryModeLabel(value) {
  const raw = String(value || '').trim().toLowerCase();
  if (raw === 'lunch') return '🥗 Lunch mode';
  if (raw === 'dinner') return '🍽️ Dinner mode';
  const key = normalizeCategoryKey(raw);
  return CATEGORY_PRESENTATION[key]?.modeLabel || '✨ Vibe mode';
}

export function getCategorySearchLabel(value) {
  const key = normalizeCategoryKey(value);
  return CATEGORY_PRESENTATION[key]?.nearbyLabel || '✨ Best Nearby Right Now';
}

export function getCategoryEndpoint(value) {
  const key = normalizeCategoryKey(value);
  return CATEGORY_PRESENTATION[key]?.endpoint || null;
}

const EXPLORE_ORDER = [
  'coffee',
  'brunch',
  'food',
  'bars',
  'hidden_gems',
  'late_night',
  'cannabis',
  'clubs',
];

export const DEFAULT_EXPLORE_CATEGORIES = Object.freeze(
  EXPLORE_ORDER.map((key) => {
    const item = CATEGORY_PRESENTATION[key];
    return Object.freeze({ key: item.key, label: item.label, emoji: item.emoji });
  })
);
